<template>
  <div fluid class="mb-4 background-container admin-home">
    <b-row>
      <div class="collections-selection background-container">
        <div class="container background-container">
          <h6 class="text-left mt-3 mb-4 pl-3">Order Status</h6>
          <div class="collections-list pl-2 pr-0">
            <el-timeline v-if="preorderDetails">
              <el-timeline-item
                v-for="(activity, index) in preorderDetails.timeline"
                :key="index"
                :color="getColorBasedOnEvent(activity.event)"
                :timestamp="activity.timestamp.toDate().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' })"
              >
                {{ activity.event }}
              </el-timeline-item>
            </el-timeline>
            <div v-else class="mt-3 ml-2 mr-2">
              <el-skeleton :rows="5" animated />
            </div>
            <el-popover
             ref="newOrderStatusPopover"
              placement="bottom"
              :width="350"
              trigger="click"
            >
              <template #reference>
                <el-button v-if="!loading" class="add-status-btn"
                  >Add Item</el-button
                >
              </template>
              <template #default>
                <el-form
                  :model="newOrderStatus"
                  :rules="orderStatusRules"
                  ref="newOrderStatusForm"
                  label-position="top"
                >
                  New Status
                  <div class="mt-3 custom-datepicker">
                    <el-form-item
                      label="Timestamp"
                      prop="timestamp"
                    >
                      <VueDatePicker
                        v-model="newOrderStatus.timestamp"
                        :min-date="minDate"
                        :dark="isDarkMode"
                      ></VueDatePicker>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="Event" prop="event" class="custom-dropdown">
                      <el-select
                        :teleported="false"
                        :model-value="newOrderStatus.event"
                        @update:model-value="newEventSelected"
                        placeholder="Select"
                        style="width: 100% !important"
                      >
                        <el-option
                          v-for="item in allowedEvents"
                          :key="item"
                          :label="item"
                          :value="item"
                      /></el-select>
                    </el-form-item>
                    <el-form-item v-if="shouldShowShippingForNewOrderStatus" label="Carrier" prop="carrier" class="custom-dropdown">
                      <el-select
                        :teleported="false"
                        :model-value="newOrderStatus.carrier"
                        @update:model-value="value => newOrderStatus.carrier = value"
                        placeholder="Select"
                        style="width: 100% !important"
                      >
                        <el-option
                          v-for="item in ['Canada Post', 'FedEx', 'UPS', 'Purolator']"
                          :key="item"
                          :label="item"
                          :value="item"
                      /></el-select>
                    </el-form-item>
                    <el-form-item v-if="shouldShowShippingForNewOrderStatus" label="Tracking Number" prop="trackingNumber">
                      <el-input
                      :model-value="newOrderStatus.trackingNumber"
                        @update:model-value="value => newOrderStatus.trackingNumber = value"
                        placeholder="Enter tracking number"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <el-button
                    @click="submitNewOrderStatus"
                    v-if="!loading"
                    class="add-status-btn"
                    >Add</el-button
                  >
                </el-form>
              </template>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="database-screen background-container">
        <div v-if="preorderDetails">
          <div class="header-container background-container">
            <div class="mt-3 mb-3 header-section background-container">
              <div class="align">
                <h6 class="document-title">Order# {{ preorderDetails.id }}</h6>
              </div>
            </div>
          </div>
          <div>
            <p class="title cell-item">
              <el-icon class="mr-2"><PriceTag /></el-icon>Order Info
            </p>
            <el-descriptions
              direction="vertical"
              :column="3"
              size="large"
              border
            >
              <el-descriptions-item
                v-for="column in tableColumns"
                :key="column.label"
                :label="column.label"
              >
                <template #default="scope">
                  <div v-if="column.property === 'status'">
                    <el-tag
                      :type="getTagColorBasedOnEvent(formatPreorderData(column))"
                      >{{ formatPreorderData(column) }}</el-tag
                    >
                  </div>
                  <div v-else>
                    {{ formatPreorderData(column) }}
                  </div>
                </template>
              </el-descriptions-item>
            </el-descriptions>
          </div>

          <div v-if="preorderDetails.shipping">
            <p class="title cell-item lavendar-background">
              <el-icon class="mr-2"><van /></el-icon>Shipping Info
            </p>
            <el-descriptions
                direction="vertical"
                :column="2"
                size="large"
                border
              >
                <el-descriptions-item
                  v-for="column in shippingColumns"
                  :key="column.label"
                  :label="column.label"
                  >
                  <div>
                    {{  preorderDetails.shipping[column.property] }} 
                  <!-- <button
             
              @click="handleEdit($index, row)"
              class="operations-btn ml-2"
            >
              <i class="ri-pencil-fill medium-icon"></i>
            </button> -->
                  </div>
                  </el-descriptions-item
                >
              </el-descriptions>
          </div>

          <el-collapse>
            <el-collapse-item
              class="collapse-info"
              name="1"
              v-if="preorderDetails[organizationOrderProperty] === 'one'"
            >
              <template #title>
                <p class="collapse-title cell-item">
                  <el-icon class="mr-2"><OfficeBuilding /></el-icon>Organization
                  Info
                </p>
              </template>
              <el-descriptions
                direction="vertical"
                :column="2"
                size="large"
                border
              >
                <el-descriptions-item
                  v-for="column in organizationColumns"
                  :key="column.label"
                  :label="column.label"
                  >{{  formatPreorderData(column) }}</el-descriptions-item
                >
              </el-descriptions>
            </el-collapse-item>

            <el-collapse-item name="2" class="collapse-info">
              <template #title>
                <p class="collapse-title cell-item">
                  <el-icon class="mr-2"> <user /> </el-icon>Customer Info
                </p>
              </template>
              <el-descriptions
                direction="vertical"
                :column="2"
                size="large"
                border
              >
                <el-descriptions-item
                  v-for="column in buyerColumns"
                  :key="column.label"
                  :label="column.label"
                  >{{  formatPreorderData(column) }}</el-descriptions-item
                >
              </el-descriptions>
            </el-collapse-item>

            <el-collapse-item name="3" class="collapse-info">
              <template #title>
                <p class="collapse-title cell-item">
                  <el-icon class="mr-2"><ChatLineRound /></el-icon>Additional
                  Questions
                </p>
              </template>
              <el-descriptions
                direction="vertical"
                :column="2"
                size="large"
                border
              >
                <el-descriptions-item
                  v-for="column in questionsColumns"
                  :key="column.label"
                  :label="column.label"
                >
                  <template #default="scope">
                    <div v-if="column.property === 'howDidYouHearAboutUs'">
                      <el-tag
                        type="info"
                        class="mr-1"
                        v-for="tag in preorderDetails['howDidYouHearAboutUs']"
                        :key="tag"
                        >{{ tag }}</el-tag
                      >
                    </div>
                    <div v-else>
                      {{ formatPreorderData(column) }}
                    </div>
                  </template>
                </el-descriptions-item>
              </el-descriptions>
            </el-collapse-item>
          </el-collapse>
          <PreorderFormVue :preorder="preorderDetails"></PreorderFormVue>
        </div>
        <div v-else class="mt-3 ml-2 mr-2">
          <el-skeleton :rows="5" animated />
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import getDocument from '../../../services/getDocument'
import PreorderFormVue from './PreorderManagementForm.vue'
import { xray } from '../../../config/pluginInit'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { ref, watch } from 'vue'
import { updateDocument } from '../../../services/useDocument'
import { Timestamp, arrayUnion } from 'firebase/firestore'
import { useStore } from 'vuex'

export default {
  name: 'PreorderDetail',
  mounted () {
    xray.index()
  },
  components: {
    PreorderFormVue,
    VueDatePicker
  },
  setup (props, context) {
    const route = useRoute()
    const organizationOrderProperty = 'isOrganizationOrder'
    const events = ['Payment received', 'Preparing Order', 'Ready for Dispatch', 'Order Shipped', 'Order Delivered']
    const allowedEvents = ref([])
    const newOrderStatusForm = ref(null)
    const { document: preorderDetails, loading } = getDocument('kneeSleevePreorders', route.params.id)
    const { handlelUpdate } = updateDocument('kneeSleevePreorders', route.params.id)
    const newOrderStatusPopover = ref(null)
    const shouldShowShippingForNewOrderStatus = ref(false)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const minDate = ref(today)
    const store = useStore()
    const isDarkMode = ref(false)

    watch(() => store.state.theme.currentTheme, (newTheme) => {
      isDarkMode.value = newTheme === 'night'
    }, { immediate: true })

    watch(() => preorderDetails.value, (newValue) => {
      if (newValue && newValue.timeline && newValue.timeline.length) {
        const latestEvent = newValue.timeline[newValue.timeline.length - 1].event
        const latestEventIndex = events.findIndex(event => event === latestEvent)
        allowedEvents.value = (latestEventIndex >= 0 && latestEventIndex < events.length - 1)
          ? events.slice(latestEventIndex + 1)
          : []
      } else {
        allowedEvents.value = events
      }
    })

    const newOrderStatus = ref({
      timestamp: null,
      event: null,
      carrier: null,
      trackingNumber: null
    })

    const tableColumns = [{
      label: 'Order ID',
      property: 'id'
    },
    {
      label: 'Order Date',
      property: 'orderDate'
    },
    {
      label: 'Status',
      property: 'status'
    },
    {
      label: 'Quantity',
      property: 'quantity'
    },
    {
      label: 'Subtotal',
      property: 'subtotal'
    },
    {
      label: 'PST (7%)',
      property: 'pst'
    },
    {
      label: 'GST (5%)',
      property: 'gst'
    },
    {
      label: 'Total',
      property: 'total'
    },
    {
      label: 'Organization Order',
      property: 'isOrganizationOrder'
    },
    {
      label: 'Payment ID',
      property: 'paymentId'
    }
    ]

    const buyerColumns = [
      {
        label: 'First Name',
        property: 'firstName'
      },
      {
        label: 'Last Name',
        property: 'lastName'
      },
      {
        label: 'Email',
        property: 'email'
      },
      {
        label: 'Phone',
        property: 'phone'
      },
      {
        label: 'Address',
        property: 'streetAddress'
      }
    ]

    const shippingColumns = [
      {
        label: 'Carrier',
        property: 'carrier'
      },
      {
        label: 'Tracking Number',
        property: 'trackingNumber'
      }
    ]

    const organizationColumns = [
      {
        label: 'Organzation Name',
        property: 'organizationName'
      },
      {
        label: 'Plan to use our product within organization',
        property: 'planToUseProduct'
      }
    ]

    const questionsColumns = [
      {
        label: 'How did you hear about us?',
        property: 'howDidYouHearAboutUs'
      },
      {
        label: 'Subscribe to our newsletter?',
        property: 'subscribe'
      },
      {
        label: 'Use Application',
        property: 'useApplication'
      },
      {
        label: 'Request Details',
        property: 'requestDetails'
      }
    ]

    const formatPreorderData = (column) => {
      if (column.property === 'orderDate') {
        return preorderDetails.value.orderDate.toDate().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })
      }

      if (column.property === 'status') {
        return preorderDetails.value.timeline ? preorderDetails.value.timeline[preorderDetails.value.timeline.length - 1].event : preorderDetails.value.status
      }

      if (column.property === 'subscribe') {
        return preorderDetails.value.subscribe ? 'Yes' : 'No'
      }
      if (column.label === 'Address') {
        const addressParts = [
          preorderDetails.value.streetAddress,
          preorderDetails.value.address2,
          preorderDetails.value.city,
          preorderDetails.value.state,
          preorderDetails.value.postalCode,
          preorderDetails.value.country
        ].filter(part => part)

        return addressParts.join(', ')
      }

      if (column.property === organizationOrderProperty) {
        return (preorderDetails.value[organizationOrderProperty] === true || preorderDetails.value[organizationOrderProperty] === 'true') ? 'Yes' : 'No'
      }

      return preorderDetails.value[column.property]
    }

    const getColorBasedOnEvent = (event) => {
      switch (event) {
        case 'Payment received':
          return '#E6A23C'
        case 'Preparing Order':
          return '#F56C6C'
        case 'Ready for Dispatch':
          return '#909399'
        case 'Order Shipped':
          return '#409eff'
        case 'Order Delivered':
          return '#67C23A'
        default:
          return '#909399'
      }
    }

    const getTagColorBasedOnEvent = (event) => {
      switch (event) {
        case 'Payment received':
          return 'warning'
        case 'Preparing Order':
          return 'danger'
        case 'Ready for Dispatch':
          return 'info'
        case 'Order Shipped':
          return 'primary'
        case 'Order Delivered':
          return 'success'
        default:
          return 'info'
      }
    }

    const newEventSelected = (value) => {
      newOrderStatus.value.event = value
      if (value === 'Order Shipped') {
        shouldShowShippingForNewOrderStatus.value = true
        orderStatusRules.carrier = [
          { required: true, message: 'Please select a carrier', trigger: 'change' }
        ]
        orderStatusRules.trackingNumber = [
          { required: true, message: 'Please enter a tracking number', trigger: 'change' }
        ]
      } else {
        shouldShowShippingForNewOrderStatus.value = false
        orderStatusRules.carrier = []
        orderStatusRules.trackingNumber = []
      }
    }

    const resetNewOrderStatusForm = () => {
      newOrderStatus.value = {
        timestamp: null,
        event: null
      }
    }

    const orderStatusRules = {
      timestamp: [
        { required: true, message: 'Please select a timestamp', trigger: 'change' }
      ],
      event: [
        { required: true, message: 'Please select an event', trigger: 'change' }
      ]
    }

    const submitNewOrderStatus = async () => {
      const isValid = await newOrderStatusForm.value.validate()
      if (isValid) {
        const timestamp = Timestamp.fromDate(newOrderStatus.value.timestamp)
        const event = newOrderStatus.value.event

        if (event === 'Order Shipped') {
          handlelUpdate({ shipping: { carrier: newOrderStatus.value.carrier, trackingNumber: newOrderStatus.value.trackingNumber } })
        }
        handlelUpdate({ timeline: arrayUnion({ timestamp, event }), status: event })
        // Close the popover
        newOrderStatusPopover.value.hide()
        resetNewOrderStatusForm()
      }
    }

    return {
      preorderDetails,
      formatPreorderData,
      tableColumns,
      buyerColumns,
      organizationColumns,
      organizationOrderProperty,
      questionsColumns,
      getColorBasedOnEvent,
      loading,
      getTagColorBasedOnEvent,
      allowedEvents,
      newOrderStatus,
      resetNewOrderStatusForm,
      orderStatusRules,
      newOrderStatusForm,
      submitNewOrderStatus,
      newOrderStatusPopover,
      minDate,
      isDarkMode,
      newEventSelected,
      shouldShowShippingForNewOrderStatus,
      shippingColumns
    }
  }
}
</script>

<style scoped>
.back-button {
  border-radius: 10px;
  border: 1px solid var(--border-color);
  color: var(--muted-text-color);
  background-color: var(--light-grey);
  padding: 0px 5px;
  font-size: 14px;
}
.align {
  display: flex;
  align-items: baseline;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border-color);
  padding: 5px 20px;
  background-color: #f4f5f7;
}

.header-section {
  display: flex;
  align-items: center;
}

.document-title {
  font-size: 14px;
}

.title {
  background: var(--light-grey);
  border-top: 1px solid var(--border-color);
  padding: 13px 15px;
  font-size: 14px;
  margin-bottom: 0px !important;
  border-bottom: 1px solid var(--border-color);
}

.collapse-title {
  padding: 10px 15px;
  font-size: 14px;
  margin-bottom: 0px !important;
}

.cell-item {
  display: flex;
  align-items: center;
}

.admin-home {
  padding: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.collections-selection {
  width: 20%;
  border-right: 1px solid var(--border-color);
  border-radius: 4px 0 0 4px !important;
}

.database-screen {
  width: 80%;
}

.icon-large {
  font-size: 3rem;
}

.add-status-btn {
  border: 1px solid var(--border-color);
  padding: 3px 0;
  width: 100%;
  color: var(--muted-text-color);
  margin-top: 20px;
  font-size: 0.85rem;
}

.container {
  background-color: white;
  font-size: 0.9rem;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 7px 0 0 7px !important;
}

.collections-list {
  overflow-y: auto;
  overflow-x: hidden;
}

.lavendar-background {
  background-color: var(--lavendar) !important;
}

.operations-btn {
  background-color: var(--dark-grey);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  padding: 2px 7px;
  margin: 0;
  font-size: 14px;
  color: var(--text-color);
}

.operations-btn.close-btn {
  background-color: var(--error-color);
  color: var(--text-color);
}
</style>

<style>
.collapse-info .el-collapse-item__content {
  padding-bottom: 0px !important;
}

.collapse-info .el-collapse-item__header.is-active {
  background: lavender !important;
}

.custom-datepicker input {
  height: 32px !important;
  font-size: 14px;
  line-height: 30px;
  color: var(--muted-text-color);
}

</style>
